import { TooltipFilled } from '@icon';
import React from 'react';
import Tooltip from '../../../../../tooltip';

interface FormTooltipProps {
  tooltipText: string;
}

const FormTooltip: React.FunctionComponent<FormTooltipProps> = ({ tooltipText }) => {
  return (
    <Tooltip
      trigger={['click']}
      placement="top"
      Icon={TooltipFilled}
      variant="large"
      content={tooltipText}
    />
  );
};

export default React.memo(FormTooltip);
